"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = arrowRenderer;
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
function arrowRenderer(_ref) {
  var theme = _ref.theme;
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    className: theme['select-arrow'],
    name: "arrow-down-small",
    size: "",
    isDecorative: true
  });
}
//# sourceMappingURL=defaultArrowRenderer.js.map